import { useState } from "react";
import ticketApi from "../api/ticketApi";


const useStatusSnippets = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<any>(null);
    const [error, setError] = useState<string | null>(null);

    const fetch = async (id:number) => {
        setLoading(true)
        const result = await ticketApi.getTicketHistory(id)
        if(result.ok){
            setLoading(false)
            setData(result.data)
            setError(null)
        }
        else {
            setLoading(false)
            setData(null)
            setError(result.originalError.message)
        }

    }


    return { fetch, loading, data, error}
}

export default useStatusSnippets